(function(){
  'use strict';
  var MONEY_FORMAT = window.PRAYASA_MONEY_FORMAT || 'Rs. {{amount}}';
  function money(cents){
    var n = (Math.round(Number(cents)||0)/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2});
    var stripped = String(MONEY_FORMAT).replace(/<[^>]*>/g,'');
    var out = stripped.replace(/\{\{[^}]+\}\}/g, n);
    if(out === stripped){ out = stripped + n; }
    return out;
  }
  function sized(url,w){ if(!url) return ''; return url + (url.indexOf('?')>-1 ? '&' : '?') + 'width=' + w; }
  function esc(s){ return String(s == null ? '' : s).replace(/"/g,'&quot;'); }

  var drawer = document.getElementById('CartDrawer');
  if(!drawer) return;
  var itemsEl = document.getElementById('CdItems');
  var emptyEl = document.getElementById('CdEmpty');
  var footEl = document.getElementById('CdFoot');
  var recsEl = document.getElementById('CdRecs');
  var recsRow = document.getElementById('CdRecsRow');
  var subtotalEl = document.getElementById('CdSubtotal');
  var saveRow = document.getElementById('CdSaveRow');
  var saveEl = document.getElementById('CdSave');
  var lastFocus = null;
  var recsLoadedFor = null;

  function lock(){ document.documentElement.classList.add('cd-lock'); document.body.classList.add('cd-lock'); }
  function unlock(){ document.documentElement.classList.remove('cd-lock'); document.body.classList.remove('cd-lock'); }

  function openDrawer(){
    lastFocus = document.activeElement;
    drawer.classList.add('cd--open');
    drawer.setAttribute('aria-hidden','false');
    lock();
    var c = drawer.querySelector('.cd__close'); if(c) c.focus();
  }
  function closeDrawer(){
    drawer.classList.remove('cd--open');
    drawer.setAttribute('aria-hidden','true');
    unlock();
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  drawer.addEventListener('click', function(e){ if(e.target.closest('[data-cd-close]')) closeDrawer(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer.classList.contains('cd--open')) closeDrawer(); });

  function setCount(n){ document.querySelectorAll('.cart .cnt').forEach(function(el){ el.textContent = n; }); }

  function renderItems(cart){
    itemsEl.innerHTML = '';
    cart.items.forEach(function(item){
      var row = document.createElement('div');
      row.className = 'cd__li';
      row.setAttribute('data-key', item.key);
      var im = '<div class="cd__li-im">' + (item.image ? ('<img src="' + sized(item.image,180) + '" alt="" loading="lazy">') : '') + '</div>';
      var mid = '<div class="cd__li-mid"><div class="cd__li-t"><a href="' + item.url + '">' + item.product_title + '</a></div>';
      if(!item.product_has_only_default_variant && item.variant_title){ mid += '<span class="cd__li-v">' + item.variant_title + '</span>'; }
      mid += '<span class="cd__li-price">' + money(item.final_price) + '</span></div>';
      var right = '<div class="cd__li-r"><div class="cd__stepper">'
        + '<button type="button" data-cd-dec aria-label="Decrease quantity">&#8722;</button>'
        + '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-cd-qty aria-label="Quantity">'
        + '<button type="button" data-cd-inc aria-label="Increase quantity">+</button>'
        + '</div><button type="button" class="cd__li-rm" data-cd-remove>Remove</button></div>';
      row.innerHTML = im + mid + right;
      itemsEl.appendChild(row);
    });
  }

  function render(cart){
    setCount(cart.item_count);
    if(cart.item_count === 0){
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.style.display = 'none';
      recsEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.style.display = '';
    renderItems(cart);
    subtotalEl.textContent = money(cart.total_price);
    if(cart.total_discount > 0){ saveRow.hidden = false; saveEl.textContent = money(cart.total_discount); }
    else { saveRow.hidden = true; }
    loadRecs(cart);
  }

  function fetchCart(cb){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); if(cb) cb(cart); })
      .catch(function(){});
  }

  function changeQty(key, qty, row){
    if(row) row.classList.add('is-busy');
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity:qty})
    })
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); })
      .catch(function(){ if(row) row.classList.remove('is-busy'); });
  }

  itemsEl.addEventListener('click', function(e){
    var row = e.target.closest('.cd__li'); if(!row) return;
    var key = row.getAttribute('data-key');
    var input = row.querySelector('[data-cd-qty]');
    var q = parseInt((input && input.value) || '1', 10) || 1;
    if(e.target.closest('[data-cd-inc]')){ changeQty(key, q + 1, row); }
    else if(e.target.closest('[data-cd-dec]')){ changeQty(key, Math.max(0, q - 1), row); }
    else if(e.target.closest('[data-cd-remove]')){ changeQty(key, 0, row); }
  });
  itemsEl.addEventListener('change', function(e){
    if(!e.target.matches('[data-cd-qty]')) return;
    var row = e.target.closest('.cd__li'); if(!row) return;
    var key = row.getAttribute('data-key');
    var q = Math.max(0, parseInt(e.target.value || '0', 10) || 0);
    changeQty(key, q, row);
  });

  function loadRecs(cart){
    if(!cart.items.length){ recsEl.hidden = true; return; }
    var pid = cart.items[0].product_id;
    if(recsLoadedFor === pid) return;
    recsLoadedFor = pid;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.products) || [];
        var inCart = {};
        cart.items.forEach(function(i){ inCart[i.product_id] = true; });
        products = products.filter(function(p){ return !inCart[p.id]; }).slice(0,6);
        if(!products.length){ recsEl.hidden = true; return; }
        recsRow.innerHTML = '';
        products.forEach(function(p){
          var variants = p.variants || [];
          var v = variants.filter(function(x){ return x.available; })[0] || variants[0];
          if(!v) return;
          var card = document.createElement('div');
          card.className = 'cd__rec';
          var img = p.featured_image ? ('<img src="' + sized(p.featured_image,260) + '" alt="" loading="lazy">') : '';
          card.innerHTML = '<div class="cd__rec-im">' + img
            + '<button type="button" class="cd__rec-add" data-cd-add="' + v.id + '" aria-label="Add ' + esc(p.title) + '">+</button></div>'
            + '<div class="cd__rec-t">' + p.title + '</div>'
            + '<div class="cd__rec-p">' + money(p.price) + '</div>';
          recsRow.appendChild(card);
        });
        recsEl.hidden = false;
      })
      .catch(function(){ recsEl.hidden = true; });
  }

  recsRow.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cd-add]'); if(!btn) return;
    var id = btn.getAttribute('data-cd-add');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(id,10), quantity:1}]})
    })
      .then(function(r){ return r.json(); })
      .then(function(){ recsLoadedFor = null; fetchCart(); })
      .catch(function(){ btn.disabled = false; });
  });

  document.querySelectorAll('a.cart, a[href$="/cart"], .dw__f a[href$="cart"]').forEach(function(a){
    a.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); fetchCart(); });
  });

  var checkoutBtn = document.getElementById('CdCheckout');
  if(checkoutBtn){ checkoutBtn.addEventListener('click', function(){ window.location.href = '/checkout'; }); }

  function maybeAddWrap(){
    var cb = document.getElementById('GiftWrap');
    var vid = window.PRAYASA_GIFTWRAP_VARIANT;
    if(!cb || !cb.checked || !vid) return Promise.resolve();
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var has = (cart.items || []).some(function(i){ return String(i.variant_id) === String(vid); });
        if(has) return;
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(vid,10), quantity:1}]})
        });
      })
      .catch(function(){});
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if(action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if(btn) btn.disabled = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:fd})
      .then(function(r){ return r.json(); })
      .then(function(){ return maybeAddWrap(); })
      .then(function(){ recsLoadedFor = null; openDrawer(); fetchCart(); })
      .catch(function(){})
      .then(function(){ if(btn) btn.disabled = false; });
  }, true);

  var promoTog = document.getElementById('CdPromoTog');
  var promoBox = document.getElementById('CdPromo');
  var promoInput = document.getElementById('CdPromoInput');
  var promoApply = document.getElementById('CdPromoApply');
  if(promoTog && promoBox){
    promoTog.addEventListener('click', function(){
      var open = promoBox.hidden;
      promoBox.hidden = !open;
      if(open && promoInput) promoInput.focus();
    });
  }
  function applyPromo(){
    var code = promoInput && promoInput.value ? promoInput.value.trim() : '';
    if(!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }
  if(promoApply){ promoApply.addEventListener('click', applyPromo); }
  if(promoInput){ promoInput.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); applyPromo(); } }); }
})();
